// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"19feedad","453":"3f753c1b","751":"17491b54","780":"a6def600","871":"64157f4e","880":"ab0f674a"}[chunkId] + ".chunk.js";
};